angular.module('impactx.search').component('ixThemeworldList', {
        bindings: {
            themeworlds: '<',
            trns: '<',
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'ThemeworldSearchListCtrl',
        controllerAs: 'themeworldSearchListCtrl',
        templateUrl: 'modules/search/templates/themeworld-list.html'
    }
);
